import React, { useState, useContext, useEffect } from "react";
import "../../styles/pages/Banners/BannerManager.scss";
import "../../styles/components/kababMenu.scss";
import ArrowWithCircle from "../../images/Arrowwithcircle.svg";
import time from "../../images/time.svg";
import { ThreeDotMenu } from "./ThreeDotMenu.js";
import {
  getSaveAssets,
  getMLRstatus,
  getbannerandTemplateDetails,
} from "../../services/apis";
import ErrComponentToRender from "../../Uitls/apiErrorHandling";
import useVisible from "./useVisible";
import BasedOnModalNew from "./BasedOnModalNew.js";
import { withRouter } from "react-router-dom";
import ValueContext from "../../ContextAPi/appContext";
import { useTranslation } from "react-i18next";
import Tooltip from "@mui/material/Tooltip";
import ClonetemplateModal from "../../Pages/TemplateManager/ClonetemplateModal.js";
import TemplateDeleteModal from "./TemplateDeleteModal";
import TemplateDetailsModal from "./TemplatesDetailModal";

function TemplatesContainer(props) {
  const appData = useContext(ValueContext);
  const {
    preDefined,
    setPredefined,
    customTemp,
    setCustomBannerSize,
    hide3dotIcon,
    getBrandsToPopulate,
  } = props;
  const { t } = useTranslation();
  let url =
    "https://imc-preview.s3.ap-south-1.amazonaws.com/ContentStudio/Banners/dummy-post-horisontal.jpg";

  const { ref, visible, setVisible } = useVisible(false);
  const [showBasedOn, setShowBasedOn] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [bannerDetails, setBannerDetails] = useState({
    assetName: "",
    assetType: "",
    brandName: "",
    bannerLink: "",
    marketName: "",
    width: "",
    height: "",
    campaign: "",
    veevaDocNumber: "",
    reviewStatus: "Not submitted",
    createdBy: "",
    createdOn: "",
    updatedBy: "",
    updatedDateTime: "",
    isAnimated: false,
    createdByName: "",
    updatedByName: "",
    createdDateTime: "",
    damDocNumber: "",
    sourceTemplateInfo: {
      assetName: "",
      brandName: "",
      campaign: "",
      marketName: "",
      createdBy: "",
      createdDateTime: "",
      updatedDateTime: "",
    },
    isBannerCreated: false,
    bannerCount: "",
  });
  const [showDetails, setShowDetails] = useState(false);
  const [showCloneTemplate, setShowCloneTemplate] = useState(false);
  const [iscustomtempSize, setIscustomtempSize] = useState(false);
  const [latestMLRStatus, setLatestMLRStatus] = useState(
    props.recentlyViewedData?.assetMlr?.filter(
      (assetObj) => assetObj.fileType === "Pdf",
    )[0]?.reviewStatus || "Not Submitted",
  );

  useEffect(() => {
    setLatestMLRStatus(
      props.recentlyViewedData?.assetMlr?.filter(
        (assetObj) => assetObj.fileType === "Pdf",
      )[0]?.reviewStatus || "Not Submitted",
    );
  }, [
    props.recentlyViewedData?.assetMlr?.filter(
      (assetObj) => assetObj.fileType === "Pdf",
    )[0]?.reviewStatus,
  ]);

  function getEditSaveAssets(id, cloneStatus, title) {
    getSaveAssets(id, async (response, err, errorCode) => {
      const data = await response.data;
      //  var cardAry = [];
      if (err) {
        const errCoponent = ErrComponentToRender(errorCode);
      } else {
        appData.setBannersEditCardData({
          cards: data,
        });

        appData.setAssetInfo({
          assetId: data.id,
          assetName: data.assetName,
        });

        let obj = {};
        obj.brandName = data.brandName;
        obj.campaign = data.campaign;
        obj.market = data.marketName;
        obj.width = data.width;
        obj.height = data.height;
        obj.isAnimated = data.isAnimated;

        appData.updateGenericInfo({
          ...appData?.genericInfo,
          brand: data.brandName,
          campaign: data.campaign,
          market: data.marketName,
          width: data.width,
          height: data.height,
          isAnimated: data.isAnimated,
          bannerNameInput: "",
        });
        appData.setAttributes(data?.attributes);
        setIscustomtempSize(data.attributes?.customTemp);
        appData.setMarketCode(data.marketCode);

        appData.setBrandId(data.brandId);
        if (title === "cloneTitle") {
          setShowCloneTemplate(true);
          setVisible(!visible);
        } else {
          setShowBasedOn(true);
        }
      }
    });
  }
  const handleDeleteTemplate = () => {
    setShowDelete(true);
    setVisible(!visible);
  };
  const handleCloneTemplate = () => {
    setShowCloneTemplate(true);
    setVisible(!visible);
  };
  const bannerImages = {
    bannerName: "Banner A",
    img: (
      <img
        src={props.recentlyViewedData.thumbNail}
        alt="Banner "
        className="img-fluid"
      />
    ),
    status: "Approved",
  };

  const handleOpenDetailsModal = () => {
    setShowDetails(true);
    getDetails();
  };
  const getDetails = () => {
    getbannerandTemplateDetails(
      props?.recentlyViewedData?.id,
      async (response, err, errorCode) => {
        const data = await response.data;

        if (err) {
          props.setLoading(false);
        } else {
          props.setLoading(false);
          setBannerDetails(response?.data);
        }
      },
    );
  };
  function createdDate(dateString) {
    const createdDate = new Date(dateString);
    const currentDate = new Date();

    // Step 1: Set the time portion of both dates to 00:00:00 to ignore time difference
    createdDate.setHours(0, 0, 0, 0);
    currentDate.setHours(0, 0, 0, 0);

    // Step 2: Calculate the difference in days
    const timeDifference = currentDate - createdDate;
    const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

    // Step 3: Determine the output
    if (daysDifference === 0) {
      return "Today"; // Same day
    } else if (daysDifference === 1) {
      return "Yesterday"; // One day ago
    } else {
      return `${daysDifference} days ago`; // More than one day ago
    }
  }
  const moduleCardMenuOptions = [
    <li className="pl-0 pr-0">
      <button
        className="btn p-0 m-0 w-100 text-left pr12 pl12 lh32"
        onClick={() => {
          appData.setFlagEditFlow(true);
          props.history.push({
            pathname: `/banner-editor/${props.recentlyViewedData?.id}`,
            state: {
              editClicked: true,
              prefillBannerName: props?.recentlyViewedData?.assetName || "",
              prefillIsAnimated: Boolean(props?.recentlyViewedData?.isAnimated),
              prefillBannerType: props?.recentlyViewedData?.isAnimated
                ? "Animated"
                : "Static",
              prefillAssetType:
                props?.recentlyViewedData?.assetType || "Template",
            },
          });
        }}
      >
        {"Edit"}
      </button>
    </li>,
    <li className="pl-0 pr-0">
      <button
        className="btn p-0 m-0 w-100 text-left pr12 pl12 lh32"
        onClick={() => {
          handleDeleteTemplate();
        }}
      >
        {"Delete"}
      </button>
    </li>,
    <li className="pl-0 pr-0">
      <button
        className="btn p-0 m-0 w-100 text-left pr12 pl12 lh32"
        onClick={async () => {
          await getEditSaveAssets(
            props.recentlyViewedData.id,
            true,
            "cloneTitle",
          );
        }}
      >
        {"Clone"}
      </button>
    </li>,
    <li className="pl-0 pr-0">
      <button
        className="btn p-0 m-0 w-100 text-left pr12 pl12 lh32"
        onClick={() => {
          handleOpenDetailsModal();
        }}
      >
        {t("Details")}
      </button>
    </li>,
  ];
  return (
    <>
      <div className="recentlyViewCardTemplates">
        <div className="bannerImagesDiv bannerImagesDivTemp">
          <div
            style={{
              height: "148px",
              backgroundImage: props?.recentlyViewedData?.thumbNail
                ? `url(${props.recentlyViewedData.thumbNail})`
                : `url(${url})`,
              backgroundSize: "contain",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
            alt="Banner"
            className="bannerImages img-fluid"
          />
          <div className="middle">
            <div
              className="overlaytext overlaytextTemp"
              onClick={async () => {
                await getEditSaveAssets(
                  props.recentlyViewedData.id,
                  true,
                  "basedOntitle",
                );
              }}
            >
              {t("bannerManager.basedOnTitle")}
              <img
                src={ArrowWithCircle}
                alt="arrow"
                className="arrowwithcircle"
              />
            </div>
          </div>
        </div>
        <div className="bannerRow bannerRowTemp"></div>
        <div className="content-block1">
          <p className="basic-info">
            <span>Name:</span>{" "}
            <Tooltip title={props.recentlyViewedData.assetName}>
              <strong className="truncate2">
                {props.recentlyViewedData.assetName}
              </strong>
            </Tooltip>
          </p>
          <p className="basic-info">
            <span>Product:</span>{" "}
            <strong className="truncate">
              {props.recentlyViewedData.brandName}
            </strong>
          </p>
        </div>
        {/* </div> */}
        <div className="edit-popup">
          <div className="time">
            <img className="timeIcon" src={time}></img>
            {createdDate(props.recentlyViewedData.createdDateTime)}
          </div>
          {hide3dotIcon ? (
            <div className="kababIcon">
              <>
                <div>
                  <ThreeDotMenu menuOptions={moduleCardMenuOptions} />
                </div>
              </>
              {false ? (
                <div className="kababMenu" ref={ref}>
                  {
                    <>
                      <div
                        className={`kababMenu--option`}
                        onClick={async () => {
                          appData.setFlagEditFlow(true);
                          props.history.push({
                            pathname: `/banner-editor/${props.recentlyViewedData?.id}`,
                            state: { editClicked: true },
                          });
                        }}
                      >
                        {t("bannerManager.kababMenu.edit")}
                      </div>
                    </>
                  }

                  <>
                    <div
                      className="kababMenu--option"
                      onClick={() => handleDeleteTemplate()}
                    >
                      {t("bannerManager.kababMenu.delete")}
                    </div>
                  </>
                  {
                    <>
                      <div
                        className="kababMenu--option"
                        onClick={async () => {
                          await getEditSaveAssets(
                            props.recentlyViewedData.id,
                            true,
                            "cloneTitle",
                          );
                        }}
                      >
                        {t("Clone")}
                      </div>
                    </>
                  }
                  <>
                    <div
                      className="kababMenu--option"
                      onClick={() => handleOpenDetailsModal("Template")}
                    >
                      {t("Details")}
                    </div>
                  </>
                </div>
              ) : null}
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="text-center">
          {showBasedOn && (
            <BasedOnModalNew
              showBasedOn={showBasedOn}
              recentlyViewedData={props.recentlyViewedData}
              setShowBasedOn={setShowBasedOn}
              getBrandsToPopulate={getBrandsToPopulate}
            />
          )}
          {showDelete && (
            <TemplateDeleteModal
              card={"TEMPLATE"}
              responseData={props.responseData}
              setResponseData={props.setResponseData}
              showDelete={showDelete}
              setShowDelete={setShowDelete}
              searchType={props.search}
              recentlyViewedData={props.recentlyViewedData}
              getRecentlyViewedBanner={props.getRecentlyViewedBanner}
              removeSearchresultCard={props.removeSearchresultCard}
            />
          )}
          {showCloneTemplate && (
            <ClonetemplateModal
              handleCloneTemplate={handleCloneTemplate}
              showCloneTemplate={showCloneTemplate}
              setShowCloneTemplate={setShowCloneTemplate}
              recentlyViewedData={props.recentlyViewedData}
              genericInfoNew={appData.genericInfo}
              preDefined={preDefined}
              setPredefined={setPredefined}
              customTemp={customTemp}
              setCustomBannerSize={setCustomBannerSize}
              iscustomtempSize={iscustomtempSize}
            />
          )}
        </div>
        {showDetails && (
          <div className="details-mod">
            <TemplateDetailsModal
              showDetails={showDetails}
              setShowDetails={setShowDetails}
              setLoading={props.setLoading}
              loading={props.loading}
              lockStatus={props.recentlyViewedData.lockStatus}
              bannerDetails={bannerDetails}
              setBannerDetails={setBannerDetails}
              recentlyViewedData={props.recentlyViewedData}
            />
          </div>
        )}
      </div>
    </>
  );
}

export default withRouter(TemplatesContainer);
